import React from 'react';
import { CrownWhite, UnlockIcon } from '../icons'; // Assuming Lock icon is not available or named differently
import { Button } from 'pages/application/Login';
import './style.css'; // We'll create this file for styling
import { useNavigate } from 'react-router-dom';

export const PermissionGuard: React.FC<{ onUnlock: () => void, yTranslation?: number }> = ({ onUnlock, yTranslation }) => {
    const navigate = useNavigate();
    if (!yTranslation) {
        yTranslation = -600;
    }
    return (
    <div className="permission-guard__container" style={{ transform: `translateX(calc(var(--parent-width) / 2 + 30px)) translateY(${yTranslation}px)` }}>
        <div className="permission-guard">
            <div className="permission-guard__header">
                <div className="permission-guard__icon-container">
                <CrownWhite />
                </div>
                <span className="permission-guard__title">Premium feature</span>
            </div>
            <Button onClick={() => {
                navigate('/main/subscription');
            }} className="permission-guard__button">
                <UnlockIcon />
                Unlock
            </Button>
        </div>
    </div>
  );
};
